module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLTPro-Roman.6f0b67a1.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/HelveticaNeueLTPro-Roman.otf
// module id = 408
// module chunks = 33